<div class="page mt-2">
  <i-title [text]="'iScan.globalInfos.treatmentScans' | translate" [buttons]="buttons"></i-title>
  <div class="mb-2"></div>
  <i-tabs-xl-v2
    [tabs]="tabs"
    [currentTabId]="tabsArrayXLActiveID"
    (onSelectTab)="changeTab($event)"
    (currentTabIdChange)="changeCurrentTabId($event)"></i-tabs-xl-v2>
  @if (columns && tableLoaded) {
    <div (dragover)="$event.preventDefault()" (drop)="onNativeDrop($event)">
      <i-dragndrop [droppableAreas]="droppableAreas()">
          <i-table
            [paginator]="true"
            class="super-table"
            [id]="'scanList_table'"
            [columns]="columns"
            [items]="items"
            [menu]="menu"
            [multiselect]="false"
            [totalRecords]="totalRecords"
            [rows]="rows"
            [firstPage]="0"
            [lazy]="true"
            (onClickRow)="modifyScan($event)"
            (onPageChange)="onLazyLoad($event)"></i-table>
        </i-dragndrop>
    </div>    
  }

  <p-overlayPanel #overlayButtonNewScan id="overlayButtonNewScan">
    <ng-template pTemplate>
      <a class="dropdown-item iScan__overlay-Panel__item iScan__overlay-Panel__item--bottom__border">
        <div class="d-flex align-items-center" (click)="setMode('Manual'); openFileSelectionModalAndHideOverlay()">
          <img
            src="../../../../assets/img/iscan-manual.svg"
            width="20"
            height="20"
            class="img-fluid"
            [alt]="'iScan.globalInfos.manualSeparation' | translate" />
          <span class="ms-2">{{ 'iScan.globalInfos.manualSeparation' | translate }}</span>
        </div>
      </a>
      <a class="dropdown-item iScan__overlay-Panel__item iScan__overlay-Panel__item--bottom__border">
        <div class="d-flex align-items-center" (click)="setMode('QRCode'); openFileSelectionModalAndHideOverlay()">
          <img
            src="../../../../assets/img/iscan-separator.svg"
            width="20"
            height="20"
            class="img-fluid"
            [alt]="'iScan.globalInfos.QRCodeKeepingSeparators' | translate" />
          <span class="ms-2">{{ 'iScan.globalInfos.QRCodeKeepingSeparators' | translate }}</span>
        </div>
      </a>
      <a class="dropdown-item iScan__overlay-Panel__item">
        <div class="d-flex align-items-center" (click)="setMode('QRCodeNotKept'); openFileSelectionModalAndHideOverlay()">
          <img
            src="../../../../assets/img/iscan-no-separator.svg"
            width="20"
            height="20"
            class="img-fluid"
            [alt]="'iScan.globalInfos.QRCodeNotKeepingSeparators' | translate" />
          <span class="ms-2">{{ 'iScan.globalInfos.QRCodeNotKeepingSeparators' | translate }}</span>
        </div>
      </a>
    </ng-template>
  </p-overlayPanel>

  <input type="file" #fileInput accept="application/pdf" multiple (change)="setInfosForUploadScanFromButton($event)" style="display: none" />
</div>

<i-modal
  [visible]="openDialogMailsLinked"
  [modalParameters]="modalParams"
  [header]="modalHeader"
  (emitterOnVisibleChange)="openDialogMailsLinked = false">
  <ng-container>
    <div>
      <i-table
        [paginator]="false"
        class="super-table"
        [id]="'documentLinkScan'"
        [items]="itemsMailsLinked"
        [columns]="columnsMailsLink"
        (onClickRow)="showDetailsSelectedMail($event)"
        [multiselect]="false"></i-table>
    </div>
  </ng-container>
</i-modal>

@if (openDialogCreateSeparatorPage) {
  <i-modal
    [visible]="openDialogCreateSeparatorPage"
    [modalParameters]="modalParams"
    [header]="modalHeaderSeparatorPage"
    (emitterOnVisibleChange)="openDialogCreateSeparatorPage = false">
    <app-separator-page></app-separator-page>
  </i-modal>
}

<p-confirmDialog #cd [header]="'global.confirmHeader' | translate" key="iScanDeletionConfirmationKey" icon="bi bi-exclamation-triangle">
  <p-footer>
    <button type="button" pButton icon="pi pi-times" label="Non" (click)="cd.reject()"></button>
    <button class="pButtonRed" type="button" pButton icon="pi pi-check" label="Oui" (click)="cd.accept()"></button> </p-footer
></p-confirmDialog>
